import invoices from '@/api/apiSferest/services/invoices'
import { modifyInvoiceTags } from '@/helpers/formatInvoice'

/**
 * Get invoice by id
 * @param {Object} payload - Basic information for invoice (invoiceType and id) to get full detail.
 */
export const getSingleInvoice = ({ commit, dispatch, state }, payload) => {
  return new Promise((resolve, reject) => {
    invoices.get[payload.invoiceType](payload.id)
    .then(res => {
      var invoice = res.data
      invoice.invoiceType = payload.invoiceType
      let paymentIndications = invoice.paymentIndications
      if (paymentIndications && paymentIndications.paymentType === '-1') invoice.paymentIndications = null
      modifyInvoiceTags(invoice)
      invoices.getAttachments(payload.id).then(res => {
        invoice.files = res.data
        dispatch('set', invoice)
        resolve(invoice)
      })
    })
  })
}

export const getAttachments = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    invoices.getAttachments(state.invoice.id)
    .then(res => {
      dispatch('files/set', res.data.map(x => ({ ...x, idI: state.invoice.id })))
      .then(() => {
        resolve()
      })
    })
  })
}

export const set = ({ commit, dispatch }, payload) => {
  return new Promise((resolve) => {
    commit('SET', payload)
    dispatch('files/set', payload.files.map(x => ({ ...x, idI: payload.id })))
      .then(() => {
        resolve()
      })
  })
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET', {})
    resolve()
  })
}
